import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';

const offset = 187;
const duration = '1.4s';
const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  spinner: {
    animation: 'rotator 1.4s linear infinite',
  },
  '@keyframes rotator': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(270deg)' },
  },
  path: {
    strokeDasharray: `${offset}`,
    strokeDashoffset: 0,
    transformOrigin: 'center',
    animation: [['dash', `${duration}`, 'ease-in-out', 'infinite'], ['colors', '5.2s', 'ease-in-out', 'infinite']],
  },

  '@keyframes colors': {
    '0%': { stroke: '#4285F4' },
    '25%': { stroke: '#DE3E35' },
    '50%': { stroke: '#F7C223' },
    '75%': { stroke: '#1B9A59' },
    '100%': { stroke: '#4285F4' },
  },

  '@keyframes dash': {
    '0%': { strokeDashoffset: `${offset}` },
    '50%': {
      strokeDashoffset: `${offset / 4}`,
      transform: 'rotate(135deg)',
    },
    '100%': {
      strokeDashoffset: `${offset}`,
      transform: 'rotate(450deg)',
    },
  },
});

class Loading extends Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <svg
          className={classes.spinner}
          width="32px"
          height="32px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle className={classes.path} fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30" />
        </svg>
      </div>
    );
  }
}
export default withStyles(styles)(Loading);



// WEBPACK FOOTER //
// ./src/modules/core/components/Loading.js